import React from 'react';
import I18n from '@/modules/i18n';
import cn from '@/utils/cn';
import { TCIDropdown } from '@/components/ui/Dropdown';
import { ISlide } from '@/components/admin/SlideShow/stores/useSlideShowStore';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import AddSlide from '@/components/admin/SlideShow/Utils/AddSlide';
import CopySlide from '@/components/admin/SlideShow/Utils/CopySlide';
import { getNewSlidePosition } from '@/components/admin/SlideShow/Utils';
import builderStyles from '../SlideShowBuilder.module.scss';
import CopySlideIdButton from './CopySlideIdButton';

interface SlideThumbnailActionsProps {
  removeModalManager: ModalManager;
  slide: ISlide;
}

// Events from the menu (trigger and portaled items alike) bubble through React to the thumbnail, which selects
// on mousedown and deletes on Backspace; stop them here so using the menu never touches the slide.
const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

const SlideThumbnailActions = ({ removeModalManager, slide }: SlideThumbnailActionsProps) => {
  const slides = useSlideShowContext(state => state.slides);
  const userType = useSlideShowContext(state => state.userType);
  const isContentManager = ['ContentManager', 'Sysadmin'].includes(userType);

  return (
    <div
      className={builderStyles.actionsButtonWrapper}
      role="presentation"
      onClick={stopPropagation}
      onKeyDown={stopPropagation}
      onMouseDown={stopPropagation}
    >
      <TCIDropdown align="start">
        <TCIDropdown.Trigger asChild>
          <button
            aria-label={I18n.t('actions')}
            className={cn(builderStyles.actionsButton, 'dropdown-toggle btn btn--outline-purple')}
            type="button"
          />
        </TCIDropdown.Trigger>
        <TCIDropdown.Content width="unset">
          <TCIDropdown.Item>
            <AddSlide
              position={getNewSlidePosition(slide, slides)}
              slideGroupId={slide.slideGroupId}
              styling="dropdown"
            />
          </TCIDropdown.Item>
          <TCIDropdown.Item>
            <CopySlide slide={slide} />
          </TCIDropdown.Item>
          {isContentManager && (
            <TCIDropdown.Item>
              <CopySlideIdButton slideId={slide.id} />
            </TCIDropdown.Item>
          )}
          <TCIDropdown.Item onSelect={removeModalManager.open}>
            Delete Slide
          </TCIDropdown.Item>
        </TCIDropdown.Content>
      </TCIDropdown>
    </div>
  );
};

export default SlideThumbnailActions;
